import axiosInstance from "./axiosInstance";

export const setUserLanguage = async () => {
    const response = await axiosInstance.post(`/users/set_language/`, {
        token: localStorage.getItem("token")
    })

    return response.data
}
